export default "__VITE_ASSET__pvvuEAjf__"